import styled from 'styled-components'

import { customMedia } from '../../utils/breakpoints';

export const MainSearch = styled.div`
  grid-area: search;
  box-sizing: border-box;
  position: relative;
  z-index: ${props => (props.showOverlay ? 20 : 8)};
  align-self: center;
  justify-self: auto;
  padding: 0 135px;

  ${customMedia.lessThan('md')`
    padding: 0 146px;
  `}

  ${customMedia.lessThan('sm')`
    padding: 0 110px;
  `}

  ${customMedia.lessThan('xs')`
    padding: 0 16px;
  `}
`

export const SeacrhFormResultsContainer = styled.div`
  position: relative;
`

export const Overlay = styled.div`
  display: ${props => (props.showOverlay ? 'block' : 'none')};
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(22, 22, 22, 0.64);
  z-index: 15;
`
